import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useInView } from 'react-intersection-observer';
import { requestApi } from 'utils/request';
import { useUI } from 'contexts/UIContext';
import SelectBox from 'components/SelectBox';
import CategoryButtonComponent from '../FAQTab/CategoryButtonComponent';
import { NoListTextTitle } from '../QnATab/style';
import { ServiceContentsList } from './style';
import { ServiceCenterContentsWrapper } from '../style';
import {
  SelectWrapper,
  TitleBox,
  TitleText,
} from '../FAQTab/SearchCategorySection/style';

const noticeCategoryList = [
  { codeName: '전체', code: '' },
  { codeName: '판매몰 공지', code: 'NCC100' },
  { codeName: '2차 인증 안내', code: 'NCC200' },
  { codeName: '중요 안내', code: 'NCC300' },
  { codeName: '서비스 이용 안내', code: 'NCC400' },
];

const NoticeTab = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // 공지사항 리스트
  const [noticeList, setNoticeList] = useState([]);

  // 판매몰 리스트
  const [mallList, setMallList] = useState([]);
  // 선택된 판매몰
  const [selectedMallSeq, setSelectedMallSeq] = useState(0);

  const { setContextLoading } = useUI();
  // 무한스크롤 여부 판단용 페이지 num 저장
  const [currentPage, setCurrentPage] = useState(1);
  const [endPage, setEndPage] = useState(2);

  // 무한스크롤
  const [ref, inView] = useInView({
    threshold: 0,
  });

  // 카테고리 선택
  const noticeCategoryCd = searchParams.get('categoryCd');

  const onClickNoticeCategoryBtn = code => {
    const newParams = new URLSearchParams(searchParams);
    if (!!code) {
      newParams.set('categoryCd', code);
    } else {
      newParams.set('categoryCd', '');
    }
    setSearchParams(newParams);
    setSelectedMallSeq(0);
  };

  const onChangeMall = event => {
    setSelectedMallSeq(event.target.value);
    getNoticeList(true, { mallSeq: event.target.value });
  };

  // 공지사항 리스트 불러오기 (첫번째 페이지 여부, params)
  const getNoticeList = async (first, params) => {
    try {
      const res = await requestApi({
        url: '/v1/na/notice',
        method: 'GET',
        params: {
          pageNo: first ? 1 : currentPage + 1,
          noticeCategoryCd,
          ...(selectedMallSeq && { mallSeq: selectedMallSeq }),
          ...params,
        },
      });
      if (res.success) {
        const { list, paging } = res?.data;
        if (first) {
          setNoticeList(list);
        } else {
          setNoticeList(prev => [...prev, ...list]);
        }
        setCurrentPage(paging?.pageNo);
        setEndPage(paging?.endPageNo);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setContextLoading(false);
    }
  };

  // 판매몰 리스트 불러오기
  const getMallList = async () => {
    try {
      const res = await requestApi({
        url: '/v1/na/faq/only-y/interlock/mall',
        method: 'GET',
        params: { dataProviderSeq: 10002 },
      });
      if (res.success) {
        const { list } = res?.data;
        setMallList([
          { label: '판매몰 전체', value: 0 },
          ...list.map(item => ({ value: item.mallSeq, label: item.mallName })),
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const selectedCategoryName = noticeCategoryList.find(
    item => item.code === noticeCategoryCd
  )?.codeName;

  useEffect(() => {
    getMallList();
  }, []);

  useEffect(() => {
    getNoticeList(true);
  }, [noticeCategoryCd]);

  // 무한 스크롤 동작
  useEffect(() => {
    if (inView && currentPage < endPage)
      setTimeout(() => {
        getNoticeList(false);
      }, 300);
  }, [inView]);

  useEffect(() => {
    if (!searchParams.has('categoryCd')) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('categoryCd', '');
      setSearchParams(newParams);
    }
  }, []);

  return (
    <ServiceCenterContentsWrapper>
      <CategoryButtonComponent
        categoryList={noticeCategoryList}
        onClickCategoryBtn={onClickNoticeCategoryBtn}
        selectedCategoryCd={noticeCategoryCd}
      />
      <TitleBox>
        <TitleText>{selectedCategoryName}</TitleText>
        {(noticeCategoryCd === 'NCC100' || noticeCategoryCd === 'NCC200') && (
          <SelectWrapper>
            <SelectBox
              optionList={mallList}
              optionHandleChange={onChangeMall}
              name="selectMall"
              value={selectedMallSeq}
              isNotDisabled={true}
              noPadding={true}
              $gray
            />
          </SelectWrapper>
        )}
      </TitleBox>
      {noticeList.length === 0 ? (
        <NoListTextTitle>
          등록된 {selectedCategoryName}가 없습니다.
        </NoListTextTitle>
      ) : (
        <ServiceContentsList>
          {noticeList.map((item, index) => {
            return (
              <li
                key={`FoldedCard_${index}`}
                onClick={() => {
                  navigate(`${item.noticeSeq}`);
                }}
              >
                <div className="textBox">
                  <div className="titleRow">{item.subject}</div>
                  <div className="descriptionRow">
                    {item.noticeCategoryNm}
                    {item.mallNm && ` | ${item.mallNm}`}
                    {item.notiPeriodStartDt && ` | ${item.notiPeriodStartDt} `}
                  </div>
                </div>
                <div className="iconWrap">
                  <FeatherIcon
                    icon="chevron-right"
                    stroke="#02A4FF"
                    size={24}
                  />
                </div>
              </li>
            );
          })}
          <div ref={ref} />
        </ServiceContentsList>
      )}
    </ServiceCenterContentsWrapper>
  );
};

export default NoticeTab;
